import React, { useState, useEffect } from "react";
import axiosInstance from "../../services/auth";
import ReactPaginate from "react-paginate";
import { toast, ToastContainer } from "react-toastify";

import CompanyForm from "./CompanyForm";
import CompanyView from "./CompanyView";
import { useCombinedContext } from "../../context/CombinedContext";

const CompanyList = () => {
  // const [company, setCompany] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [selectedData, setSelectedData] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [isViewMode, setIsViewMode] = useState(false);
  const [loading, setLoading] = useState(false);

  const { selectedCompany, company, setCompany } = useCombinedContext();

  const companyId = selectedCompany?._id;
  // console.log("companyId: " , companyId)

  //  console.log("company data",company)
  // console.log("This is Selected ", selectedData);
  useEffect(() => {
    fetchCompany();
  }, [companyId]);

  const fetchCompany = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(`/company`);
      // console.log("company response", response);
      //  setCompany(response.data.data || []);
      setFilterData(response.data.data || []);
    } catch (error) {
      // console.error("Error fetching company:", error);
      toast.error("Error fetching company");
    } finally {
      setLoading(false);
    }
  };

  // Filter Job Location
  const handleSearchChange = (e) => {
    const searchText = e.target.value.toLowerCase();
    const filteredLocation = company.filter(
      (company) =>
        company?.company_code?.toString().toLowerCase().includes(searchText) ||
        company?.company_name?.toString().toLowerCase().includes(searchText) ||
        company?.bank_account_no?.toString().toLowerCase().includes(searchText),
    );
    setFilterData(filteredLocation);
  };

  const deleteCompany = async (_id) => {
    try {
      await axiosInstance.patch(`/company/${_id}`);
      fetchCompany();
    } catch (error) {
      // console.error("Error deleting company:", error);
      toast.error("Error deleting company");
    }
  };
  //Delete Data
  const handleDelete = (id) => {
    // console.log(id);
    setDeleteTarget(id); // Set the target ID for deletion
    setIsDeleteModalOpen(true);
  };
  const confirmDelete = async () => {
    if (!deleteTarget) return; // Ensure a valid target is set
    try {
      await axiosInstance.delete(`/company/${deleteTarget}`);
      setCompany((prev) => prev.filter((loc) => loc._id !== deleteTarget));
      setFilterData((prev) => prev.filter((loc) => loc._id !== deleteTarget));
      setIsDeleteModalOpen(false); // Close the modal after successful deletion
      setDeleteTarget(null); // Clear the delete target
      toast.success("Location deleted successfully");
    } catch (error) {
      // console.error("Error deleting location:", error);
      toast.error("Failed to delete location");
    }
  };

  //Handle Page Location
  const handlePageClick = (selectedPage) => {
    setCurrentPage(selectedPage.selected);
  };
  const itemsPerPage = 5; // Adjust this for the number of items per page
  const currentItems = filterData.slice(
    currentPage * itemsPerPage,
    (currentPage + 1) * itemsPerPage,
  );
  const pageCount = Math.ceil(filterData.length / itemsPerPage);

  return (
    <div>
      <ToastContainer />
      <div className="headStyle d-flex justify-content-between align-items-center">
        {/* <h2>fetchCompany</h2>
        <button
          className="btn btn-primary"
          onClick={() => {
            setSelectedData(null);
            setShowForm(true);
          }}
        >
          Create Company
        </button> */}
        {/* <input
          className="form-control"
          type="search"
          placeholder="Search..."
          style={{ maxWidth: "200px", border: "1px solid #1E2A5E" }}
          onChange={handleSearchChange}
        /> */}
        <h4 className="mb-0">Company</h4>
        <button
          className="button-2 "
          onClick={() => {
            setSelectedData(null);
            setShowForm(true);
          }}
        >
          Add Company
        </button>
      </div>
      <div className="headStyle mt-4">
        <div
          className="my-3 rounded "
          style={{
            overflowX: "auto",
          }}
        >
          <table className="table table-bordered table-responsive mb-0">
            <thead className="t_head">
              <tr className="text-center align-middle">
                <th rowSpan="2" className="align-middle">
                  Sl No
                </th>
                <th rowSpan="2" className="align-middle">
                  Company Name
                </th>
                <th rowSpan="2" className="align-middle">
                  Company Code
                </th>
                <th rowSpan="2" className="align-middle">
                  Bank Account No
                </th>
                <th rowSpan="2" className="align-middle">
                  Co Reg No
                </th>
                <th rowSpan="2" className="align-middle">
                  Vessel Code Starting No
                </th>
                <th rowSpan="2" className="align-middle">
                  GST No
                </th>
                <th rowSpan="2" className="align-middle">
                  GST %
                </th>
                <th rowSpan="2" className="align-middle">
                  Address
                </th>
                <th rowSpan="2" className="align-middle">
                  Telephone
                </th>
                <th rowSpan="2" className="align-middle">
                  Fax
                </th>
                <th rowSpan="2" className="align-middle">
                  Email
                </th>
                <th rowSpan="2" className="align-middle">
                  Status
                </th>
                <th rowSpan="2" className="text-center align-middle ">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="18">
                    <div className="d-flex justify-content-center m-3">
                      <div className="spinner"></div>
                    </div>
                  </td>
                </tr>
              ) : (
                <>
                  {currentItems.length === 0 ? (
                    <>
                      <tr>
                        <td colSpan="14">
                          <div className="d-flex justify-content-center m-1">
                            <h6>Data Not Found</h6>
                          </div>
                        </td>
                      </tr>
                    </>
                  ) : (
                    <>
                      {currentItems &&
                        currentItems.map((company, index) => (
                          <tr key={company.id || index}>
                            <td>{currentPage * itemsPerPage + index + 1}</td>
                            <td>{company.company_name}</td>
                            <td>{company.company_code}</td>
                            <td>{company.bank_account_no}</td>
                            <td>{company.co_regno}</td>
                            <td>{company.vessal_code_starting_no}</td>
                            <td>{company.gst_no}</td>
                            <td>{company.gst_pct}</td>
                            <td>{company.address}</td>
                            <td>{company.telephone}</td>
                            <td>{company.fax}</td>

                            <td>{company.email}</td>
                            <td
                              className={
                                company.status ? "text-primary" : "text-danger"
                              }
                            >
                              {company.status ? "Active" : "Inactive"}
                            </td>
                            <td>
                              <div className="d-flex justify-content-center gap-2">
                                <button
                                  className="btn btn-outline-primary btn-sm me-2"
                                  onClick={() => {
                                    setSelectedData(company);
                                    setIsViewMode(true);
                                  }}
                                >
                                  <i className="bi bi-folder2-open"></i>
                                </button>
                                <button
                                  className="btn btn-outline-success btn-sm me-2"
                                  onClick={() => {
                                    setSelectedData(company);
                                    setShowForm(true);
                                  }}
                                >
                                  <i className="bi bi-pencil-square"></i>
                                </button>
                                {/* Uncomment this section if needed */}
                                {/* <button
    className="btn btn-outline-danger btn-sm"
    onClick={() => handleDelete(company._id)}
  >
    <i className="bi bi-trash3"></i>
  </button> */}
                              </div>
                            </td>
                          </tr>
                        ))}
                    </>
                  )}
                </>
              )}
            </tbody>
          </table>
        </div>

        <ReactPaginate
          breakLabel="..."
          nextLabel="next >"
          onPageChange={handlePageClick}
          pageRangeDisplayed={5}
          pageCount={pageCount}
          previousLabel="< previous"
          renderOnZeroPageCount={null}
          containerClassName="pagination justify-content-center pagination-sm"
          pageClassName="page-item"
          pageLinkClassName="page-link"
          activeClassName="active"
          previousClassName="page-item"
          previousLinkClassName="page-link"
          nextClassName="page-item"
          nextLinkClassName="page-link"
          disabledClassName="disabled"
        />

        {isViewMode && (
          <CompanyView
            company={selectedData}
            isViewMode={isViewMode}
            setIsViewMode={setIsViewMode}
          />
        )}

        {showForm && (
          <CompanyForm
            company={selectedData}
            setCompany={setCompany}
            onClose={() => {
              setShowForm(false);
              fetchCompany();
            }}
          />
        )}
        {isDeleteModalOpen && (
          <div
            className={`modal fade ${isDeleteModalOpen ? "show d-block" : ""}`}
            style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)" }}
            tabIndex="-1"
            role="dialog"
            aria-labelledby="deleteModalLabel"
            aria-hidden={!isDeleteModalOpen}
            onClick={(e) => {
              if (e.target.classList.contains("modal"))
                setIsDeleteModalOpen(false);
            }}
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="deleteModalLabel">
                    Confirm Deletion
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={() => setIsDeleteModalOpen(false)}
                  ></button>
                </div>
                <div className="modal-body">
                  Are you sure you want to delete this Company? This action
                  cannot be undone.
                </div>
                <div className="modal-footer">
                  <button
                    className="btn btn-secondary"
                    onClick={() => setIsDeleteModalOpen(false)}
                  >
                    Cancel
                  </button>
                  <button className="btn btn-danger" onClick={confirmDelete}>
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CompanyList;
